module.exports = __webpack_public_path__ + "static/img/A38.b3c60594.jpg";